import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getRequestHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.get,
      endPoint.dynamicList({ path: "requests", ...action.payload }),
    );
    yield put({
      type: types.GET_REQUEST_SUCCESS,
      payload: data.response,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.GET_REQUEST_ERROR,
      payload,
    });
  }
}

export function* getRequestWatcherSaga() {
  yield takeLatest(types.GET_REQUEST_START, getRequestHandlerSaga);
}

//delete

function* deleteRequestHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.delete,
      endPoint.deleteDyanamicItem("requests", action.payload),
    );
    yield put({
      type: types.DELETE_REQUEST_SUCCESS,
      payload: data,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.DELETE_REQUEST_ERROR,
      payload,
    });
  }
}

export function* deleteRequestWatcherSaga() {
  yield takeLatest(types.DELETE_REQUEST_START, deleteRequestHandlerSaga);
}

//single item

function* getSingleRequestHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.get,
      endPoint.dynamicList({ path: `requests/${action.payload}` }),
    );
    yield put({
      type: types.SINGLE_REQUEST_SUCCESS,
      payload: data.response,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.SINGLE_REQUEST_ERROR,
      payload,
    });
  }
}

export function* getSingleRequestWatcherSaga() {
  yield takeLatest(types.SINGLE_REQUEST_START, getSingleRequestHandlerSaga);
}

//update
function* updateRequestHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { path, dataId, body } = action.payload;
    const { data } = yield call(
      apiClient.put,
      path,
      { _id: dataId, ...body }
    );
    yield put({
      type: types.UPDATE_REQUEST_SUCCESS,
      payload: data,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.UPDATE_REQUEST_ERROR,
      payload,
    });
  }
}

export function* updateRequestWatcherSaga() {
  yield takeLatest(types.UPDATE_REQUEST_START, updateRequestHandlerSaga);
}